const getters = {
  token: state => state.user.token,
  refreshToken: state => state.user.refreshToken,
  userInfo: state => state.user.userInfo,
  accountInfo: state => state.user.accountInfo,
  bossescount: state => state.user.bossescount,
  masterInfo: state => state.user.masterInfo,
  adminUuid: state => state.user.adminUuid,
  systemUuid: state => state.user.systemUuid,
  abTest: state => state.user.abTest,
  mySkills: state => state.user.mySkills,
  showNewerReward: state => state.user.showNewerReward,
  newDiscount: state => state.user.newDiscount,
  firstRecharge: state => state.user.firstRecharge,
  isAllowThirty: state => state.user.isAllowThirty,


  tabBar: state => state.app.tabBar,
  offLine: state => state.app.offLine,
  requestError: state => state.app.requestError,
  isReview: state => state.app.isReview,
  routesHistory: state => state.app.routesHistory,
  playingVoice: state => state.app.isPlayingVoice,
  rankingReload: state => state.app.rankingReload,
  lastRankingUuid: state => state.app.lastRankingUuid,
  onlyVoiceText: state => state.app.onlyVoiceText,
  commentGiftInfo: state => state.app.commentGiftInfo,
  avatarBorder: state => state.app.avatarBorder,
  avatarLevel: state => state.app.avatarLevel,
  aliasList: state => state.app.aliasList,
  newUserCouponPrice: state => state.app.newUserCouponPrice,
  skillInfo: state => state.skill.skillInfo,
  gameInfo: state => state.skill.gameInfo,
  reddotInfo: state => state.skill.reddotInfo,
  quickSkills: state => state.skill.quickSkills,
  newerCoupon(s, getters) {
    const uInfo = getters.userInfo || {};
    if (!uInfo.uuid) return 0;
    const couponList = getters.accountInfo.couponInfoList || [];
    const coupon = couponList.find(item => {
      return item.couponKind == 'NEWCOMER_EXPERIENCE' && item.couponStatus === 'EFFECT';
    });
    return coupon || 0;
  },
  // 用于极速约单新人优惠ab逻辑，单数保持原状
  newCouponAB(s, getters) {
    const info = getters.userInfo || {}
    const uuid = info.uuid || 1
    return !(uuid % 2)
  },
  quickOrderTheme: state => state.activity.quickOrderTheme,
  hasMyProcessingOrder: state => state.activity.hasMyProcessingOrder
}

export default getters
